var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23393 2.63434C8.54634 2.32192 9.05288 2.32192 9.3653 2.63434L14.1653 7.43434C14.4777 7.74676 14.4777 8.25329 14.1653 8.56571L9.3653 13.3657C9.05288 13.6781 8.54634 13.6781 8.23393 13.3657C7.92151 13.0533 7.92151 12.5468 8.23393 12.2343L11.6682 8.80002L2.39961 8.80003C1.95778 8.80002 1.59961 8.44185 1.59961 8.00002C1.59961 7.5582 1.95778 7.20002 2.39961 7.20002H11.6682L8.23393 3.76571C7.92151 3.45329 7.92151 2.94676 8.23393 2.63434Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c1856d5ba276c1e1302080bbc2781c6b.svg";
export { ForwardRef as ReactComponent };